import { currentUser, type CurrentUser } from '@occ/contracts';
import { get } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Identidad del operador en curso.
 *
 * Se cachea en memoria porque tres sitios la necesitan a la vez —`getIdentity`
 * de Refine, el control de acceso y la barra superior— y ninguno debería
 * disparar su propia petición a `/auth/me`. Se invalida en logout y cuando el
 * backend responde 401.
 */

let cached: CurrentUser | null = null;
let inFlight: Promise<CurrentUser | null> | null = null;

export const getCurrentUser = async (): Promise<CurrentUser | null> => {
  if (cached) return cached;
  inFlight ??= get(ROUTES.me, currentUser)
    .then((user) => {
      cached = user;
      return user;
    })
    .catch(() => null)
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
};

/** Lectura sin efectos, para código síncrono que solo quiere pintar lo que ya sabe. */
export const peekCurrentUser = (): CurrentUser | null => cached;

export const setCurrentUser = (user: CurrentUser | null): void => {
  cached = user;
};

export const clearCurrentUser = (): void => {
  cached = null;
  inFlight = null;
};
